import api from "services/api";

/**
 * Fetch Today's Status Report (Tasks, Remarks, Breaks, Timeline, KPIs)
 * @param {Object} params - { date: 'YYYY-MM-DD', employee_id: number }
 */
export const getDailyStatusReport = async (params = {}) => {
  return api.get("/v1/api/daily-status/report", {
    params,
  });
};

/**
 * Add a daily status remark
 * @param {Object} data - { report_date, category, remark, employee_id, update_attendance }
 */
export const addDailyStatusRemark = async (data = {}) => {
  return api.post("/v1/api/daily-status/remark", data);
};

/**
 * Delete a daily status remark
 * @param {string|number} id - remark id
 */
export const deleteDailyStatusRemark = async (id) => {
  return api.delete(`/v1/api/daily-status/remark/${id}`);
};

/**
 * Fetch Team Today's Summary (for managers/companies)
 * @param {Object} params - { date: 'YYYY-MM-DD' }
 */
export const getTeamDailyStatusSummary = async (params = {}) => {
  return api.get("/v1/api/daily-status/team-summary", {
    params,
  });
};
